import { render, staticRenderFns } from "./SanteDeces.vue?vue&type=template&id=affe416a&scoped=true&"
import script from "./SanteDeces.vue?vue&type=script&lang=js&"
export * from "./SanteDeces.vue?vue&type=script&lang=js&"
import style1 from "./SanteDeces.vue?vue&type=style&index=1&id=affe416a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "affe416a",
  null
  
)

export default component.exports